module.exports = __webpack_public_path__ + "img/evaluate_active_7.9b8e9a5b.png";